/*
Copyright 2026 Dexnet / iON.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

/*
 * A stand-in for the iON guest service until it exists (BACKEND №28), turned
 * on with `call_links.stub` in config.json. The code chooses the answer:
 *   expired…  → 410 ION_LINK_EXPIRED
 *   revoked…  → 410 ION_LINK_REVOKED
 *   missing…  → 404
 *   full…     → the page loads, joining answers 409 ION_LINK_FULL
 *   busy…     → the page loads, joining answers 429
 *   anything else → the page loads; joining returns credentials that no
 *   homeserver knows, so signing in fails: there is no stub for Matrix.
 */

import {
  CallLinkError,
  type CallLinkInfo,
  type CallLinksApi,
  type GuestCredentials,
} from "./callLinksApi";

const DELAY_MS = 400;

const delay = async (): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, DELAY_MS));

export function createCallLinksStub(): CallLinksApi {
  return {
    async getLink(code): Promise<CallLinkInfo> {
      await delay();
      if (code.startsWith("expired")) throw new CallLinkError("expired");
      if (code.startsWith("revoked")) throw new CallLinkError("revoked");
      if (code.startsWith("missing")) throw new CallLinkError("not_found");
      return {
        roomId: "!stub-call-room:7ion.org",
        title: "Звонок · iON",
        creator: { userId: "@stub-creator:7ion.org", displayName: "Анна" },
        expiresAt: Date.now() + 24 * 60 * 60 * 1000,
      };
    },

    async join(code): Promise<GuestCredentials> {
      await delay();
      if (code.startsWith("full")) throw new CallLinkError("full");
      if (code.startsWith("busy")) throw new CallLinkError("rate_limited");
      return {
        userId: "@guest-stub:7ion.org",
        accessToken: "stub-token",
        deviceId: "STUBDEVICE",
        roomId: "!stub-call-room:7ion.org",
        homeserver: "https://7ion.org",
        state: "knocking",
      };
    },
  };
}
